import { format, isValid, parseISO } from "date-fns";

export const formatDate = (date: string): string => {
  const parsedDate = parseISO(date);
  if (isValid(parsedDate)) {
    return format(parsedDate, "LLL dd, yyyy");
  }
  return date;
};

export const formatDateWithTime = (
  date: string | null | undefined,
): string => {
  if (!date) return "—";

  const parsedDate = parseISO(date);
  if (isValid(parsedDate)) {
    return format(parsedDate, "LLL dd, yyyy h:mm a");
  }

  return date;
};
